import PrestadoresHabilitadosListWrapper from './PrestadoresHabilitadosListWrapper';

export default PrestadoresHabilitadosListWrapper;
